import React from 'react';
import { Code, Database, Server, Settings, Palette } from 'lucide-react';
import './Skills.css';

const Skills = () => {
    const skillCategories = [
        {
            icon: <Code size={48} />,
            title: "Core Backend",
            skills: [
                "Python Programming",
                "Django Framework",
                "Django REST Framework",
                "Object-Oriented Programming",
                "Design Patterns",
                "Redis",
                "Celery"
            ]
        },
        {
            icon: <Database size={48} />,
            title: "Database & Storage",
            skills: [
                "PostgreSQL",
                "MySQL",
                "SQLite",
                "Database Design",
                "Query Optimization"
            ]
        },
        {
            icon: <Server size={48} />,
            title: "API Development",
            skills: [
                "RESTful APIs",
                "API Documentation",
                "Authentication & Authorization",
                "Data Serialization",
                "API Testing"
            ]
        },
        {
            icon: <Settings size={48} />,
            title: "Tools & Testing",
            skills: [
                "Git Version Control",
                "Unit Testing",
                "Postman",
                "VS Code",
                "Linux/Unix",
                "Docker"
            ]
        },
        {
            icon: <Palette size={48} />,
            title: "Additional Skills",
            skills: [
                "React",
                "HTML5",
                "CSS3",
                "JavaScript",
                "Responsive Design"
            ]
        }
    ];

    return (
        <section id="skills" className="container">
            <div className="section-header">
                <h2 className="section-title">Technical Skills</h2>
                <p className="section-subtitle">My backend development expertise</p>
            </div>
            <div className="skills-container">
                {skillCategories.map((category, index) => (
                    <div key={index} className="skill-category">
                        <div className="skill-icon">
                            {category.icon}
                        </div>
                        <h3>{category.title}</h3>
                        <ul className="skill-list">
                            {category.skills.map((skill, skillIndex) => (
                                <li key={skillIndex}>{skill}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Skills;